import { snackStore } from 'stores';

import { SNACK_SCOPES } from '../../../constants';

let snackId: void | string;

function show() {
  clean();

  const snackParams = {
    i18key: 'registration.payment.awaiting',
  };

  clean();
  snackId = snackStore.warn(snackParams, { scope: SNACK_SCOPES.payment });
}

function clean() {
  snackId && snackStore.removeValue(snackId);
}

const awaitingSnack = {
  show,
  clean,
};

export { awaitingSnack };
